import Users from './Users.component';

const Examiners: React.FC = () => {
  return <Users />;
};

export default Examiners;
